import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { css, TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { __Consolidation, enum__Consolidation } from '../../../../../../common/Dictionaries';
import { useSelector } from 'react-redux';
import { calulateSystenDecimal, formatNumber, isNullOrEmpty } from '../../../../../../common/Helpers';

function ItemGroup(props) {
  	const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        inputParam_Object = null,
    } = props;

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });

    const generateDom = () => {
        return inputParam_Object &&
            <>
                <div style={{width: "100%"}}>
                    <div style={{fontSize: "11px"}}>
                        <div className='my-1 ps-0 pe-1 text-start'>
                            <TooltipHost
                                overflowMode={TooltipOverflowMode.Self}
                                hostClassName={css(classNames.overflow)}
                                content={ inputParam_Object.name }
                                onTooltipToggle={false}
                                styles={{
                                    root: { display: 'block', height: "22px", position: "relative" },
                                }}
                            >
                                <div style={{fontSize: "15px", position: "absolute"}}>
                                    {inputParam_Object.name}
                                </div>
                            </TooltipHost> 
                        </div>
                    </div>
                </div>
                <div className='px-0 my-auto' style={{width: "100%"}}>
                    <div style={{width: "100%"}}>
                        <TooltipHost content={ inputParam_Object.scopeValue !== undefined && inputParam_Object.scopeValue !== null ? `${inputParam_Object.scopeValue}%` : t('no-data') } >
                            <div value-id={inputParam_Object.id} className={`cursor-pointer border my-1 px-2 text-center ${ " variable-value-color-" + inputParam_Object.color } `}>
                                {`${inputParam_Object.scopeValue !== undefined && inputParam_Object.scopeValue !== null ? `${formatNumber(inputParam_Object.scopeValue)}%` : t('no-data')}`}
                            </div>
                        </TooltipHost> 
                    </div>
                </div>
            </>
    }

    return (
        <>
            { generateDom() }
        </>
    );
}

ItemGroup.propTypes = {
    inputParam_Object: PropTypes.object.isRequired,
};

export default ItemGroup;